import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const SalaryDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Salary Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <ul className="">
            <li>
              <h4>Salary Type</h4>
              <h6>{employee?.salaryType}</h6>
            </li>
            <li>
              <h4>Salary</h4>
              <h6>
                {employee?.salaryType === "Monthly"
                  ? employee?.basicSalary
                  : employee?.salaryType === "Daily"
                  ? employee?.daySalary
                  : employee?.salaryType === "Hourly"
                  ? employee?.hourlySalary
                  : ""}
              </h6>
            </li>
            <li>
              <h4>HaveOver Time Pay</h4>
              <h6>{employee?.haveOverTimePay ? "Yes" : "No"}</h6>
            </li>
          </ul>
        </div>
       
      </div>
    </div>
  );
};

SalaryDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default SalaryDetails;
